/* eslint-disable */
import React from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStore } from 'src/onboarding/store/store';
import { Screen, Title, Subtitle } from './Screen';
import { trackFromGender, img } from './hairstyle';
import styles from './ImageSelect.module.scss';

type Opt = { id: string };

type Props = {
  page: string;            // route id, e.g. 'hairstyle-style-like'
  progress: number;
  field: string;           // store field, e.g. 'hairstyleStyleLike'
  setter: string;          // store setter, e.g. 'setHairstyleStyleLike'
  ns: string;              // localization namespace, e.g. 'hairstyleStyleLike'
  options: Opt[];
  hasSubtitle?: boolean;
};

/**
 * Image-grid single-select — a 2-column grid of photo tiles with a label.
 * Photos are resolved from assets/images/hairstyle/{track}/{ns}/{id}. Until the
 * designer adds them, each tile shows a labelled gradient placeholder (never breaks).
 * Tapping a tile records the answer and auto-advances (mirrors SingleSelect).
 */
export const ImageSelect: React.FC<Props> = ({ page, progress, field, setter, ns, options, hasSubtitle }) => {
  const value = useStore((s: any) => s[field]) as string | undefined;
  const setValue = useStore((s: any) => s[setter]) as (v: any) => void;
  const gender = useStore((s: any) => s.hairstyleGender);
  const { onNext, onPrev, currentIndex } = useNav();
  const track = trackFromGender(gender);

  const handleSelect = (id: string) => {
    setValue(id);
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page, answer: id });
    setTimeout(() => onNext(), 200);
  };

  return (
    <Screen progress={progress} hideBack={currentIndex === 0} onBack={onPrev}>
      <Title>{t(`${ns}.title`)}</Title>
      {hasSubtitle && <Subtitle>{t(`${ns}.subtitle`)}</Subtitle>}
      <div className={styles.grid}>
        {options.map((opt) => {
          const src = img(track, `${ns}/${opt.id}`);
          const selected = value === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              className={`${styles.tile} ${selected ? styles.selected : ''}`}
              onClick={() => handleSelect(opt.id)}
            >
              <span className={styles.thumb}>
                {src
                  ? <img src={src} alt="" className={styles.thumbImg} />
                  : <span className={styles.placeholder} aria-hidden="true">{t(`${ns}.options.${opt.id}`).charAt(0)}</span>}
              </span>
              <span className={styles.label}>{t(`${ns}.options.${opt.id}`)}</span>
            </button>
          );
        })}
      </div>
    </Screen>
  );
};

export default ImageSelect;
